import { createSelector } from 'reselect'



export const getSearchResults = (state) => ((state.searchResults || {}).results || {})
